const personColors = ['#ffa500', '#ffd426', '#00bfff' ,'#0000cd', '#dda0dd', '#ff2d55', '#00ff00', '#f5deb3', '#a0522d', '#2f4f4f', '#ffa07a'];
const MAX_SPEAKERS = personColors.length;
const NEW_UTTERANCE_TEXT = '<Enter New Utterance>';
const nonVerbal = [
    '<UNINTELLIGIBLE>',
    '<SHOUTING>',
    '<SCREAMING>',
    '<LAUGHING>',
    '<CRYING>',
    '<SIGH>',
    '<NONENGLISH>',
    '<SINGING>',
    '<MUSIC>',
    '<VOICEASSISTANT>',
    '<MOCKING>',
];
export { personColors, NEW_UTTERANCE_TEXT, MAX_SPEAKERS, nonVerbal };
